// extracted by mini-css-extract-plugin
module.exports = {"button":"button-2fO5n"};